<template>
    <v-container fluid :style="{ width: $vuetify.display.lgAndUp ? '50%' : '100%' }">
        <Form v-slot="{ meta }">
            <v-form id="focusLockDialogForm" @submit.prevent="submitRegistration(teilnehmer)">
                <v-row>
                    <v-col sm="12">
                        <v-card>
                            <v-col class="px-16 pt-10" sm="12">
                                <h3 v-text="$t('registration.description')" />
                            </v-col>
                            <v-col class="px-16" sm="12">
                                <Field v-slot="{ errors, field }" name="TVS-Nummer" :rules="getValidation('teilnehmerApiDto.kundenNummer')">
                                    <v-text-field
                                        id="TvsNummerInput"
                                        v-bind="field"
                                        v-model.number="teilnehmer.kundenNummer"
                                        :label="$t('registration.label.tvsnummer') + '*'"
                                        :placeholder="$t('registration.placeholder.tvsnummer')"
                                        :error-messages="errors"
                                    ></v-text-field>
                                </Field>
                                <Field v-slot="{ errors, field }" name="Anrede" :rules="getValidation('teilnehmerApiDto.anrede')">
                                    <v-select
                                        v-bind="field"
                                        v-model="teilnehmer.anredeTypCode"
                                        :items="anredeList"
                                        :label="$t('registration.label.anrede') + '*'"
                                        :error-messages="errors"
                                        :menu-props="{ attach: '#focusLockDialogForm' }"
                                    ></v-select>
                                </Field>
                                <v-select
                                    v-model="teilnehmer.titelTypCode"
                                    :items="titelList"
                                    :label="$t('registration.label.titel')"
                                    :menu-props="{ attach: '#focusLockDialogForm' }"
                                ></v-select>
                                <Field v-slot="{ errors, field }" name="Vorname" :rules="getValidation('teilnehmerApiDto.vorname')">
                                    <v-text-field
                                        v-bind="field"
                                        v-model="teilnehmer.vorname"
                                        :label="$t('registration.label.vorname') + '*'"
                                        :placeholder="$t('registration.label.vorname')"
                                        :error-messages="errors"
                                    ></v-text-field>
                                </Field>
                                <Field v-slot="{ errors, field }" name="Nachname" :rules="getValidation('teilnehmerApiDto.name')">
                                    <v-text-field
                                        v-bind="field"
                                        v-model="teilnehmer.name"
                                        :label="$t('registration.label.nachname') + '*'"
                                        :placeholder="$t('registration.label.nachname')"
                                        :error-messages="errors"
                                    ></v-text-field>
                                </Field>
                                <v-text-field
                                    v-model="teilnehmer.firma"
                                    :label="$t('registration.label.firma')"
                                    :placeholder="$t('registration.label.firma')"
                                ></v-text-field>
                                <Field v-slot="{ errors, field }" name="Strasse" :rules="getValidation('teilnehmerApiDto.strasse')">
                                    <v-text-field
                                        v-bind="field"
                                        v-model="teilnehmer.strasse"
                                        :label="$t('registration.label.strasse') + '*'"
                                        :placeholder="$t('registration.label.strasse')"
                                        :error-messages="errors"
                                    ></v-text-field>
                                </Field>
                                <v-text-field
                                    v-model="teilnehmer.zusatz"
                                    :label="$t('registration.label.adresszusatz')"
                                    :placeholder="$t('registration.label.adresszusatz')"
                                />
                                <Field v-slot="{ errors, field }" name="Plz" :rules="getValidation('teilnehmerApiDto.plz')">
                                    <v-text-field
                                        v-bind="field"
                                        v-model.number="teilnehmer.plz"
                                        :label="$t('registration.label.plz') + '*'"
                                        :placeholder="$t('registration.label.plz')"
                                        :error-messages="errors"
                                    ></v-text-field>
                                </Field>
                                <v-text-field
                                    v-model="teilnehmer.ort"
                                    :label="$t('registration.label.ort')"
                                    :placeholder="$t('registration.label.ort')"
                                ></v-text-field>
                                <Field
                                    v-slot="{ errors, field }"
                                    name="Telefon"
                                    :rules="getValidation('teilnehmerApiDto.telefon') + '|valid_swiss_telephone_number'"
                                >
                                    <v-text-field
                                        v-bind="field"
                                        v-model="teilnehmer.telefon"
                                        :label="$t('registration.label.telefon') + '*'"
                                        placeholder="+41 31 111 22 33"
                                        :error-messages="errors"
                                    ></v-text-field>
                                </Field>
                                <Field
                                    v-slot="{ errors, field }"
                                    name="TelefonMobil"
                                    :rules="getValidation('teilnehmerApiDto.telefonMobil') + '|valid_swiss_telephone_number'"
                                >
                                    <v-text-field
                                        v-bind="field"
                                        v-model="teilnehmer.telefonMobil"
                                        :label="$t('registration.label.telefonmobil') + '*'"
                                        placeholder="+41 77 111 22 33"
                                        :error-messages="errors"
                                    ></v-text-field>
                                </Field>
                                <Field v-slot="{ errors, handleChange, handleBlur }" name="Sprache" :rules="getValidation('teilnehmerApiDto.sprache')">
                                    <v-select
                                        :model-value="teilnehmer.sprache"
                                        :items="spracheList"
                                        :label="$t('registration.label.sprache') + '*'"
                                        :error-messages="errors"
                                        :menu-props="{ attach: '#focusLockDialogForm' }"
                                        @update:model-value="
                                            (val) => {
                                                teilnehmer.sprache = val;
                                                handleChange(val);
                                            }
                                        "
                                        @blur="handleBlur"
                                    />
                                </Field>
                                <Field v-slot="{ errors, field }" name="Email" :rules="getValidation('teilnehmerApiDto.email')">
                                    <v-text-field
                                        v-bind="field"
                                        v-model="teilnehmer.email"
                                        :label="$t('registration.label.email') + '*'"
                                        :placeholder="$t('registration.label.email')"
                                        :error-messages="errors"
                                    ></v-text-field>
                                </Field>
                                <Field v-slot="{ errors, field }" name="Referrer" rules="required">
                                    <v-select
                                        v-bind="field"
                                        v-model="referrerSelection"
                                        :items="referrerItemList"
                                        :label="$t('registration.label.referrer') + '*'"
                                        :error-messages="errors"
                                        :menu-props="{ attach: '#focusLockDialogForm' }"
                                        @update:model-value="handleReferrerChange"
                                    ></v-select>
                                </Field>
                                <v-text-field
                                    v-if="isSonstiges"
                                    v-model="teilnehmer.referrer"
                                    :label="$t('registration.label.referrer.sonstiges')"
                                    :placeholder="$t('registration.label.referrer.sonstiges')"
                                ></v-text-field>
                            </v-col>
                            <v-row class="px-16 py-10">
                                <v-col sm="6" class="pt-0 d-flex justify-start">
                                    <v-btn
                                        type="submit"
                                        :disabled="!meta.valid || requiredFieldsFilled || registrationButtonDisabled"
                                        large
                                        color="primary"
                                        class="py-3 px-6"
                                    >
                                        {{ $t('registration.button.confirm') }}
                                    </v-btn>
                                </v-col>
                                <v-col sm="6" class="pt-0 d-flex justify-start">
                                    <v-btn large color="grey-lighten-3" link class="py-3 px-6" @keydown.tab="handleLastTabKeydown" @click="openVetdataInNewTab">
                                        {{ $t('registration.button.cancel') }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-form>
        </Form>
    </v-container>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-facing-decorator';
import { namespace } from 'vuex-facing-decorator';
import { RegisterDto } from '@/types/UserDtos';

import { Form, Field } from 'vee-validate';

import { NAME as NAME_REGISTRATION } from '../store';
import { NAME as NAME_GENERAL } from '@/store/modules/general';
import { NAME as NAME_VALIDATION } from '@/store/modules/validation';
import { NAME as NAME_RESOURCE } from '@/store/modules/resource';

const resourceModul = namespace(NAME_RESOURCE);
const registrationModul = namespace(NAME_REGISTRATION);
const generalModul = namespace(NAME_GENERAL);
const validationModul = namespace(NAME_VALIDATION);

import { REQUEST_CREATE_TEILNEHMER } from '../store/actions';
import { SUBTITLE, FOOTERTITLE } from '@/store/modules/general/mutations';
import { GET_VALIDATION_KEY } from '@/store/modules/validation/getters';
import { GET_LANGUAGE } from '@/store/modules/resource/getters';

@Component({
    components: {
        Form,
        Field
    }
})
export default class Registration extends Vue {
    @generalModul.Mutation(SUBTITLE) setSubTitle!: Function;
    @generalModul.Mutation(FOOTERTITLE) setFooterTitle!: Function;

    @resourceModul.Getter(GET_LANGUAGE) language!: string;

    @registrationModul.Action(REQUEST_CREATE_TEILNEHMER) createTeilnehmerIfValid!: Function;

    @validationModul.Getter(GET_VALIDATION_KEY) getValidation!: (key: string) => string;

    registrationButtonDisabled = false;
    isSonstiges = false;
    referrerSelection = '';
    get anredeList(): Array<any> {
        return [
            { value: 'Herr', title: this.$t('registration.anrede.herr') },
            { value: 'Frau', title: this.$t('registration.anrede.frau') },
            { value: 'Herren', title: this.$t('registration.anrede.herren') },
            { value: 'HerrUndFrau', title: this.$t('registration.anrede.herrundfrau') },
            { value: 'Firma', title: this.$t('registration.anrede.firma') }
        ];
    }
    get titelList(): Array<any> {
        return [
            { value: '', title: '-' },
            { value: 'MedVet', title: this.$t('registration.titel.medvet') },
            { value: 'DrMedVet', title: this.$t('registration.titel.drmedvet') },
            { value: 'ProfDr', title: this.$t('registration.titel.profdr') },
            { value: 'DresMedVet', title: this.$t('registration.titel.dresmedvet') }
        ];
    }
    get spracheList(): Array<any> {
        return [
            { value: 'D', title: this.$t('registration.sprache.deutsch') },
            { value: 'F', title: this.$t('registration.sprache.franzoesisch') }
        ];
    }
    get referrerItemList(): Array<any> {
        return [
            { value: 'Empfehlung', title: this.$t('registration.referrer.empfehlung') },
            { value: 'LinkedIn', title: this.$t('registration.referrer.linkedin') },
            { value: 'Newsletter', title: this.$t('registration.referrer.newsletter') },
            { value: 'TVS', title: this.$t('registration.referrer.tvs') },
            { value: 'Lieferanten', title: this.$t('registration.referrer.lieferanten') },
            { value: 'Sonstiges', title: this.$t('registration.referrer.sonstiges') }
        ];
    }
    teilnehmer: RegisterDto = new RegisterDto();

    created() {
        this.setSubTitle(this.$t('registration.title'));
        this.setFooterTitle('S030');
        this.teilnehmer = new RegisterDto();
    }

    mounted() {
        // Auto focus when form is mounted
        this.$nextTick(() => {
            const firstInput = document.getElementById('TvsNummerInput') as HTMLElement | null;
            firstInput?.focus();
        });
    }

    handleReferrerChange(value: string) {
        if (value === 'Sonstiges') {
            this.isSonstiges = true;
            this.teilnehmer.referrer = ''; // user will type their own
        } else {
            this.isSonstiges = false;
            this.teilnehmer.referrer = value; // predefined option
        }
    }

    get requiredFieldsFilled(): boolean {
        let invalidKn = false;
        if (this.teilnehmer.kundenNummer === undefined) {
            invalidKn = true;
        } else if (this.teilnehmer.kundenNummer.toString() === '') {
            invalidKn = true;
        }
        let invalidPlz = false;
        if (this.teilnehmer.plz === undefined) {
            invalidPlz = true;
        } else if (this.teilnehmer.plz.toString() === '') {
            invalidPlz = true;
        }
        return (
            invalidKn ||
            invalidPlz ||
            this.teilnehmer.telefon.length === 0 ||
            this.teilnehmer.telefonMobil.length === 0 ||
            this.teilnehmer.email.length === 0 ||
            this.teilnehmer.anredeTypCode.length === 0 ||
            this.teilnehmer.vorname.length === 0 ||
            this.teilnehmer.name.length === 0 ||
            this.teilnehmer.strasse.length === 0 ||
            this.teilnehmer.sprache.length === 0
        );
    }

    private submitRegistration(teilnehmer: RegisterDto) {
        this.registrationButtonDisabled = true;
        this.createTeilnehmerIfValid(teilnehmer);
        setTimeout(() => {
            this.registrationButtonDisabled = false;
        }, 3000);
    }

    private openVetdataInNewTab() {
        if (this.language.toLowerCase() == 'de') {
            window.open(config.VUE_APP_AGB_LINK_GERMAN);
        } else if (this.language.toLowerCase() == 'fr') {
            window.open(config.VUE_APP_AGB_LINK_FRENCH);
        }
    }

    handleLastTabKeydown() {
        // Find the first input in your form and focus it
        console.log('tabbing');
        // Hier ist ein 'Hack': Fokus springt automatisch auf das nächste Ziel, aus unerklärtem Grund.
        // Wenn wir auf Language Select zielen, landen wir auf TVS-Nummer.
        const firstInput = document.getElementById('languageSelect') as HTMLElement | null;
        firstInput?.focus();
    }
}
</script>
